module.exports = __webpack_public_path__ + "static/media/Scenario3Two.414f1c06.jpg";